import { css } from '@emotion/core';
import { tokens, variables, globalTokens } from '@domain-group/fe-brary';
import * as designSystem from '@domain-group/fe-co-allhomes-design-system';
var global = variables.global;
var colors = tokens.colors;
export var underlay = /*#__PURE__*/css("position:fixed;top:0;left:0;width:100%;height:100%;z-index:", global.layerModal, ";overflow-x:hidden;overflow-y:hidden;text-align:center;background:", colors.neutral.heavy.default, ";cursor:pointer;");
export var dialog = {
  name: "265n7x",
  styles: "width:100%;height:100%;display:inline-block;text-align:left;top:0;max-width:100%;cursor:default;"
};
export var buttonBar = /*#__PURE__*/css("position:absolute;top:0;width:100%;z-index:", global.layerFloating, ";padding-top:4px;padding-left:2px;display:flex;justify-content:stretch;align-items:center;");
var whiteGhostButton = /*#__PURE__*/css("color:", colors.neutral.subdued.default, ";filter:drop-shadow(2px 2px 2px rgb(0 0 0 / 0.4));:hover,:focus{color:", colors.neutral.subdued.hover, ";outline:none;}:active{color:", colors.neutral.subdued.pressed, ";}");
export var closeButton = /*#__PURE__*/css(whiteGhostButton, ";");
export var navButton = /*#__PURE__*/css(whiteGhostButton, ";");
export var contents = {
  name: "uwwqev",
  styles: "width:100%;height:100%;"
};
export var photoCount = /*#__PURE__*/css(designSystem.typography.body, ";color:", globalTokens.colors.white, ";flex-grow:1;");